import { render, staticRenderFns } from "./TaskContextMenu.vue?vue&type=template&id=7a36a8d3&scoped=true&"
import script from "./TaskContextMenu.vue?vue&type=script&lang=js&"
export * from "./TaskContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./TaskContextMenu.vue?vue&type=style&index=0&id=7a36a8d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a36a8d3",
  null
  
)

export default component.exports